module.exports = __webpack_public_path__ + "static/media/IDB-Lab.4cfc3bfd.gif";